import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MUIPaper from '@material-ui/core/Paper'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(7, 5),
    borderRadius: ({ variant }) => (variant === 'rounded' ? 15 : 0),
    boxShadow: theme.shadows[1],
  },
}))

const Paper = ({ children, className, variant }) => {
  const classes = useStyles({ variant })

  return (
    <MUIPaper className={`${classes.root} ${className}`}>{children}</MUIPaper>
  )
}

export default Paper
